import React from "react";

function NotFound() {
  return (
    <aside className="main_content access-denied">
      <div className="m-3 mb-0 bg-white px-3 br_8 main_content_height">
        <div className="ml-auto mr-auto text-center access-denied-wrapper">
          <h1>
            {" "}
            <i className="fa fa-times-circle-o text-danger" aria-hidden="true"></i> <span>Page not found.</span>
          </h1>
          <p>
            The page you are looking for might have been removed
            <br />
            had its name changed or is temporarily unavailable.
          </p>
        </div>
      </div>
    </aside>
  );
}

export default NotFound;
